<template>
  <svg
    width="16"
    height="16"
    viewBox="0 -1 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8872 3.33406C10.5017 2.94854 9.87894 2.94854 9.49342 3.33406L4.95613 7.87135C4.57061 8.25687 4.57061 8.87964 4.95613 9.26516L9.49342 13.8024C9.87894 14.188 10.5017 14.188 10.8872 13.8024C11.2728 13.4169 11.2728 12.7942 10.8872 12.4086L7.05179 8.56331L10.8872 4.72787C11.2728 4.34235 11.2629 3.7097 10.8872 3.33406Z"
      :fill="styleVars[fill]"
    />
  </svg>
</template>

<script setup lang="ts">
import type { StyleColors } from '@/constants/styleColors'
import { styleVars } from '@/constants/styleVariables'

withDefaults(defineProps<{ fill?: StyleColors }>(), { fill: 'gray6' })
</script>
